<template>
    <project-template>

        <project-video
        size="100"
        videoID="350169164" />

        <project-image
        size="50"
        path="/img/p/bicduo/cinema1.jpg"
        alt="Cinema4D Screenshot"/>

        <project-image
        size="50"
        path="/img/p/bicduo/cinema2.jpg"
        alt="Cinema4D Screenshot"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'

export default {
  components: { ProjectTemplate, ProjectImage, ProjectVideo }
}
</script>

<style lang="scss" scoped>

</style>
